import { Box } from '@fhs-legacy/universal-components';

export const UpsellCarouselWrapper = Box.withConfig({
  marginLeft: 4,
  _web: {
    marginTop: 3,
  },
});
